"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowDown = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var defaultSize = 12;

function ArrowDown(_a) {
  var children = _a.children,
      fill = _a.fill,
      _b = _a.size,
      size = _b === void 0 ? defaultSize : _b,
      props = tslib_1.__rest(_a, ["children", "fill", "size"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    width: "".concat(size / 16, "rem"),
    height: "".concat(size / 16, "rem"),
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    d: "M8.638 11.296a.667.667 0 01-.471.196h-.338a.684.684 0 01-.47-.196l-4.56-4.569a.444.444 0 010-.631l.63-.631a.436.436 0 01.622 0L7.998 9.42l3.947-3.955a.444.444 0 01.63 0l.623.631a.444.444 0 010 .631l-4.56 4.569z",
    fill: fill
  }));
}

exports.ArrowDown = ArrowDown;